module.exports = __webpack_public_path__ + "img/sign-out-blue.4d8d42f7.svg";